// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___18SBg","m-signature-pad--body":"styles__m-signature-pad--body___23m7A","m-signature-pad--footer":"styles__m-signature-pad--footer___2sfBQ","description":"styles__description___gCtdc","button":"styles__button___1LuKq","clear":"styles__clear___rY_ES","save":"styles__save___NILMu","m-signature-pad":"styles__m-signature-pad___2Lwnv","github":"styles__github___1dyhS","seeBtnContainer":"styles__seeBtnContainer___qi3BN","seeBtnModalStyles":"styles__seeBtnModalStyles___x46ZM","seeBtnModalHover":"styles__seeBtnModalHover___2DbXR"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/EstimatorAPButton/styles.scss
// module id = 5HtU
// module chunks = client